import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=3282aecc&scoped=true"
import script from "./Standard.vue?vue&type=script&lang=js"
export * from "./Standard.vue?vue&type=script&lang=js"
import style0 from "./Standard.vue?vue&type=style&index=0&id=3282aecc&prod&lang=scss"
import style1 from "./Standard.vue?vue&type=style&index=1&id=3282aecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282aecc",
  null
  
)

export default component.exports